var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "field-form" },
    [
      !_vm.inited
        ? _c("c-loader", { attrs: { active: !_vm.inited, height: 100 } })
        : _vm.hasAvailableTypes
        ? [
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.submit.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "form-group field-form__type" },
                  [
                    _c("c-input", {
                      attrs: {
                        type: "select",
                        label: "Поле/блок",
                        searchable: true,
                        items: _vm.fieldTypes,
                      },
                      model: {
                        value: _vm.form.fieldType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "fieldType", $$v)
                        },
                        expression: "form.fieldType",
                      },
                    }),
                  ],
                  1
                ),
                _c("complex-field-form", {
                  attrs: {
                    form: _vm.complex,
                    field: _vm.field,
                    "field-type": _vm.currentFieldType,
                  },
                  on: { editDictionary: _vm.onEditDictionary },
                }),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("c-checkbox", {
                      attrs: {
                        type: "checkbox",
                        label: "Показывать в мобильном приложении",
                      },
                      model: {
                        value: _vm.form.mobile,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "mobile", $$v)
                        },
                        expression: "form.mobile",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("c-checkbox", {
                      attrs: {
                        type: "checkbox",
                        label: "Доступно сотруднику для редактирования",
                      },
                      model: {
                        value: _vm.form.available,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "available", $$v)
                        },
                        expression: "form.available",
                      },
                    }),
                  ],
                  1
                ),
                _vm.canBeRequired
                  ? _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("c-checkbox", {
                          attrs: { type: "checkbox", label: "Обязательное" },
                          model: {
                            value: _vm.form.required,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "required", $$v)
                            },
                            expression: "form.required",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.isList
                  ? _c("list-params", {
                      attrs: {
                        form: _vm.form,
                        "field-name": _vm.currentFieldName,
                        "field-type": _vm.currentFieldType,
                      },
                      on: { change: _vm.onEditListDictionary },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _c("div", { staticClass: "no-types" }, [
            _vm._v("Все системные поля добавлены в анкету"),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }